/*
 * @Author: caiqin.xie
 * @since: 2023-07-14 10:30:10
 * @lastTime: 2023-11-09 14:38:56
 * @LastEditors: caiqin.xie
 * @message: 博客搜索结果页
 * @url: www.picoxr.com/cn/blog/search/?keyword=xx
 */
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "@/components/Header/index";
import Footer from "@/components/Footer/index";
import Pagination from "@/components/Pagination";
import ResultList from "./components/ResultList";
import SearchInput from "./components/SearchInput";
import { useDevice } from '@/hooks'
import request from '@/common/request'
import { DOMAIN_API, BLOGTYPE, COUNTRY_LIST, COUNTRY_HREFLANG } from '@/common/const'
import { getUrlData } from '@/common/untils'
import { IBlogItem } from "@/common/types";
import styles from "./index.module.scss";
const _ = require("lodash");

interface IPayload {
  stationCode: string; // 站点
  rows: number; // 每页条数
  page: number; // 当前页码
  keyword: string; // 搜索关键字
}

const BlogSearch = (props: any) => {
  const {ctry, words, data} = props.data
  const device = useDevice()
  const {search} = useLocation()
  const query = getUrlData(decodeURIComponent(search)) // 获取url参数
  const [keyword, setkeyword] = useState<string>(query.keyword as string || '') // 搜索关键字
  const [pageNum, setPageNum] = useState<number>(query.page ? Number(query.page) : 1) // 当前页码
  const [pages, setPages] = useState<number>(data.pages * 1 || 1) // 总页数
  const [total, setTotal] = useState<number>(data.total * 1 || 0) // 总条数
  const [blogList, setBlogList] = useState<IBlogItem[]>(data.records || []) // 博客列表
  const [allBlogList, setAllBlogList] = useState<IBlogItem[]>(data.records || []) // 所有博客

  // 获取博客列表 (处理pad和移动端分页数据)
  const getBlogList = (pageNum: number) => {
    const payload = {
      stationCode: ctry,
      rows: 10,
      page: pageNum,
      keyword
    }
    getList(payload)
    .then((res:any) => {
      const {total, records, pages} = res
      setTotal(total * 1)
      setPages(pages * 1)
      setBlogList(records)
      setAllBlogList(allBlogList => _.uniqBy([...allBlogList, ...records], 'id'))
    })
    .catch(err => {
      console.log(err)
    })
  }

  // 搜索
  const searchBlog = () => {
    setAllBlogList([])
    window.open(`/${ctry}/blog/search?keyword=${keyword}`, '_self')
  }

  // 分页改变
  const pageChange = (pageNum:number) => {
    setPageNum(pageNum)
    if (device === 'pc') {
      if (pageNum === 1) {
        window.open(`/${ctry}/blog/search?keyword=${keyword}`, '_self')
      } else {
        window.open(`/${ctry}/blog/search?keyword=${keyword}&page=${pageNum}`, '_self')
      }
    } else {
      getBlogList(pageNum)
    }
  }

  return (
    <div>
      <Helmet>
        <title>{words?.blog_search_seo_title}</title>
        <meta name="description" content={words?.blog_search_seo_description} />
        <meta name="keywords" content={words?.blog_search_seo_keywords} />
        <link rel="canonical" href={`${DOMAIN_API}/${ctry}/blog/search`} />
        {COUNTRY_LIST.map(item => (
          <link key={item} rel="alternate" hrefLang={COUNTRY_HREFLANG[item]} href={`${DOMAIN_API}/${item}/blog/search`} />
        ))}
      </Helmet>
      <Header ctry={ctry} words={words}/>
      <main className={styles['result-wrap']}>
        <div className={styles['result-content-wrap']}>
          {/* 搜索 */}
          <div className={styles['result-search-wrap']}>
            <SearchInput
             ctry={ctry}
             words={words}
             keyword={keyword}
             setkeyword={setkeyword}
             searchBlog={searchBlog} />
          </div>
          <p className={styles['total-result']}>{total} results found</p>
          <div className={styles['result-list']}>
            {/* 搜索结果列表 */}
            <ResultList
              ctry={ctry}
              device={device}
              blogList={blogList}
              allBlogList={allBlogList} />
          </div>
          {/* 分页 */}
          <Pagination
            words={words}
            device={device}
            pageNum={pageNum}
            pages={pages}
            total={total}
            pageChange={pageChange} />
        </div>
      </main>
      <Footer />
    </div>
  );
};

// 获取列表公共方法
function getList (payload: IPayload) {
  return new Promise((resolve, reject) => {
    request.post(`${DOMAIN_API}/o/content/list`, {
      contentTypeId: BLOGTYPE,
      ...payload
    })
    .then(res => {
      resolve(res.data)
    })
    .catch(err => {
      reject(err)
    })
  })
}

BlogSearch.getInitialProps = (ctry: string, pathName: string) => {
  const decodedUrl = decodeURIComponent(pathName);
  const query = getUrlData(decodedUrl)
  return getList({
    stationCode: ctry,
    page: query.page ? Number(query.page) : 1,
    rows: 10,
    keyword: query?.keyword as string || '',
  })
};
export default BlogSearch;
